@if (!hidden) {
<div class="airwallex-rfi-widget" [ngStyle]="contentStyle">
  @if(message) {<p class="airwallex-rfi-widget__copy">{{ message }}</p>}

  @if(error) {<p class="airwallex-rfi-widget__error">{{ error }}</p>}
  @if(loading && !error) { <p class="airwallex-rfi-widget__loading">Loading verification form…</p>}

  <div #rfiHost class="airwallex-rfi-widget__host"></div>
</div>
}